class StoreList {
  data: StoreItem[];

  constructor(params: StoreItem[]) {
    this.data = params;
  }
}

export { StoreList };
